import {closest} from '../abstract/helpers.js';

export class Menu {
  constructor() {

    if(document.querySelector('header .header-navigation a')) {

      document.querySelectorAll('header .header-navigation a,header .header-navigation .open-dropdown,header .user-navigation a,header .user-navigation .open-dropdown').forEach(function(el) {
        if(el.nextElementSibling) {
          if(el.nextElementSibling.classList.contains("dropdown")) {

            el.parentNode.addEventListener("mouseenter", function(e) { this.showDropdown(el, e) }.bind(this));
            el.parentNode.addEventListener("click", function(e) { this.showDropdown(el, e) }.bind(this));
            //el.parentNode.addEventListener("touchstart", function(e) { this.showDropdown(el, e) }.bind(this));
  
          }
        }
                
      }.bind(this));

      //remove drop down if use hovers over search
      document.querySelector('.search-navigation.fixed').addEventListener("mouseenter", function(e) { this.enableSearch }.bind(this));
      document.querySelector('.search-navigation.fixed').addEventListener("click", function(e) { this.enableSearch }.bind(this));
      //document.querySelector('.search-navigation.fixed').addEventListener("touchstart", function(e) { this.enableSearch }.bind(this));

    }

    if(document.querySelector('header')) {

      document.querySelector('header').addEventListener("mouseleave", this.removeHovers );
      document.querySelector('.bg-blur').addEventListener("click", this.removeHovers );
      //document.querySelector('.bg-blur').addEventListener("touchstart", this.removeHovers);
      window.addEventListener('scroll',this.removeHovers);
    }
  }



  showDropdown(el, e) {
    if(!closest(e.target, '.dropdown')) {
      e.preventDefault();
    }
    document.querySelectorAll('header .header-navigation li, header .user-navigation li').forEach(function(el) {

      el.classList.remove('visible');
              
    });

    el.parentNode.classList.add('visible');
    document.querySelector('.bg-blur').classList.add('active');

  }

  removeHovers(e) {
    document.querySelectorAll('header .header-navigation li, header .user-navigation li').forEach(function(el) {
          
      el.classList.remove('visible');
      document.querySelector('.bg-blur').classList.remove('active');
              
    });
  }

  enableSearch(e) {
    e.preventDefault();
    document.querySelectorAll('header .header-navigation li').forEach(function(el) {
      
      el.classList.remove('visible');
      document.querySelector('.bg-blur').classList.remove('active');
              
    });
  }
}
